import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/img/chevron_left.svg'
import _imports_1 from '@/img/chevron_right.svg'
import _imports_2 from '@/img/defaultprofile.jpg'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "boxTitle" }
const _hoisted_4 = { class: "monthNavigator" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "center" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = {
  key: 1,
  class: "myTeam"
}
const _hoisted_14 = { class: "d-flex justify-content-between" }
const _hoisted_15 = { class: "boxTitle text-left" }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = { class: "label label-blue" }
const _hoisted_18 = { class: "label label-green ml-1" }
const _hoisted_19 = { class: "label label-red ml-1" }
const _hoisted_20 = { class: "boxTitle text-right" }
const _hoisted_21 = { class: "fatturato" }
const _hoisted_22 = { class: "usersContainer pt-4" }
const _hoisted_23 = { class: "users" }
const _hoisted_24 = { class: "barre" }
const _hoisted_25 = { class: "scatola" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "image" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  src: _imports_2
}
const _hoisted_30 = { class: "name" }
const _hoisted_31 = { class: "lower" }
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "fatturatoValue" }
const _hoisted_34 = { class: "mt-2" }
const _hoisted_35 = { class: "label" }
const _hoisted_36 = { class: "fatturatoValue" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_38 = {
  style: {"width":"100%","overflow-x":"scroll","overflow-y":"hidden"},
  ref: "networkContainerScroller"
}
const _hoisted_39 = {
  key: 0,
  class: "networkContainer",
  ref: "networkContainer"
}
const _hoisted_40 = { class: "d-flex justify-content-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_barre_risultato = _resolveComponent("barre-risultato")!
  const _component_node = _resolveComponent("node")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Il mio team",
          text: "Il mio team"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-hollow",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevMonth && _ctx.prevMonth(...args)))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.periodo), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-hollow",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
          }, _hoisted_11)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Legenda",
                    text: "Legenda"
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Obiettivo",
                      text: "Obiettivo"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Superato",
                      text: "Superato"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Da raggiungere",
                      text: "Da raggiungere"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Fatturato",
                    text: "Fatturato"
                  })
                ]),
                _createElementVNode("div", _hoisted_21, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.fatturato)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subUsers, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "column",
                    key: i
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_barre_risultato, { user: item }, null, 8, ["user"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", {
                        class: "upper pointer",
                        onClick: ($event: any) => (_ctx.$router.push('/dashboard/' + item.identifier))
                      }, [
                        _createElementVNode("div", _hoisted_27, [
                          (item.imageUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: item.imageUrl
                              }, null, 8, _hoisted_28))
                            : (_openBlock(), _createElementBlock("img", _hoisted_29))
                        ]),
                        _createElementVNode("div", _hoisted_30, _toDisplayString(item.name), 1)
                      ], 8, _hoisted_26),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Fatturato struttura",
                              text: "Fatturato struttura"
                            })
                          ]),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$filters.currency(item.fatturato)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "% sul tuo fatturato",
                              text: "% sul tuo fatturato"
                            })
                          ]),
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$filters.currency(_ctx.getRisultatoPerc(item))) + " %", 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              (_ctx.firstNode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_component_node, {
                      node: _ctx.firstNode,
                      allowNavigation: false,
                      class: "_singleNode",
                      open: true,
                      isCommerciale: true,
                      onOpened: _ctx.calcPadding
                    }, null, 8, ["node", "onOpened"])
                  ], 512))
                : _createCommentVNode("", true)
            ], 512),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link text-bold",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/network/commerciale')))
              }, [
                _createElementVNode("u", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Mostra Network",
                    text: "Mostra Network"
                  })
                ])
              ])
            ])
          ]))
    ])
  ]))
}